import React from 'react'
import OthersHero from './OthersHero'

const AboutHero = () => {
  return (
    <>
        <div className="about-hero-wrapper h-75">
            <OthersHero otherheading='About US'/>
        </div>
    </>
  )
}

export default AboutHero